import { render } from "./SummaryTitle.vue?vue&type=template&id=058cd9ee&scoped=true"
import script from "./SummaryTitle.vue?vue&type=script&lang=js"
export * from "./SummaryTitle.vue?vue&type=script&lang=js"

import "./SummaryTitle.vue?vue&type=style&index=0&id=058cd9ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058cd9ee"]])

export default __exports__